import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TelemetryStorage } from './telemetry-storage';
import { TelemetryIdResolver } from './telemetry-id-resolver';
import { TelemetryEndpointResolver } from './telemetry-endpoint-resolver';
import { TelemetryIsActiveResolver } from './telemetry-is-active-resolver';
import { TelemetryEvent } from './telemetry-event';

@Injectable({
	providedIn: 'root'
})
export class TelemetryService {
	constructor(
		@Inject('TelemetryStorage') private storage: TelemetryStorage,
		@Inject('TelemetryIdResolver') private idResolver: TelemetryIdResolver,
		@Inject('TelemetryEndpointResolver') private endpointResolver: TelemetryEndpointResolver,
		@Inject('TelemetryIsActiveResolver') private isActiveResolver: TelemetryIsActiveResolver,
		private http: HttpClient
	) {}
	/**
	 * trackEvent
	 * @param referrerId
	 * @param pageName
	 * @param description
	 */
	async trackEvent(
		referrerId: string,
		data: { [key: string]: any },
		pageName: string = location.pathname,
		description: string = ''
	): Promise<void> {
		if (this.isActiveResolver.isActive()) {
			const { userAgent } = navigator;
			const event: TelemetryEvent = {
				referrerId,
				clientInfo: {
					userAgent
				},
				user: {
					id: this.idResolver.getId(),
					connection: this.idResolver.getConnection() || ''
				},
				pageName,
				description,
				utcTimestamp: new Date().getTime(),
				data
			};
			try {
				await this.send(event).toPromise();
			} catch (e) {
				await this.storage.add(event);
			}
		}
	}
	/**
	 * send
	 * @param event
	 */
	send(event: TelemetryEvent): Observable<any> {
		return this.http.post(this.endpointResolver.getEndpoint(), event);
	}
}
